// Generated by purs version 0.14.4
import * as Affjax from "../Affjax/index.js";
import * as Affjax_ResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax_StatusCode from "../Affjax.StatusCode/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Foreign from "../Foreign/index.js";
var ServerError = (function () {
    function ServerError(value0) {
        this.value0 = value0;
    };
    ServerError.create = function (value0) {
        return new ServerError(value0);
    };
    return ServerError;
})();
var NetworkError = (function () {
    function NetworkError() {

    };
    NetworkError.value = new NetworkError();
    return NetworkError;
})();
var DecodingError = (function () {
    function DecodingError(value0) {
        this.value0 = value0;
    };
    DecodingError.create = function (value0) {
        return new DecodingError(value0);
    };
    return DecodingError;
})();
var ApplicationError = (function () {
    function ApplicationError(value0) {
        this.value0 = value0;
    };
    ApplicationError.create = function (value0) {
        return new ApplicationError(value0);
    };
    return ApplicationError;
})();
var simpleRequest = function (request) {
    return function (decode) {
        var handleResponse = function (v) {
            if (v instanceof Data_Either.Left) {
                return new Data_Either.Left(NetworkError.value);
            };
            if (v instanceof Data_Either.Right) {
                if (Data_Eq.eq(Affjax_StatusCode.eqStatusCode)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "status";
                    }
                })())(Data_Symbol.SProxy.value)(v.value0))(200)) {
                    var v1 = Control_Monad_Except.runExcept(decode(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "body";
                        }
                    })())(Data_Symbol.SProxy.value)(v.value0)));
                    if (v1 instanceof Data_Either.Left) {
                        return Data_Either.Left.create(DecodingError.create(Data_Show.show(Data_List_Types.showNonEmptyList(Foreign.showForeignError))(v1.value0)));
                    };
                    if (v1 instanceof Data_Either.Right) {
                        return Control_Applicative.pure(Data_Either.applicativeEither)(v1.value0);
                    };
                    throw new Error("Failed pattern match at Utils.DataLoading (line 68, column 11 - line 70, column 30): " + [ v1.constructor.name ]);
                };
                if (Data_Boolean.otherwise) {
                    return Data_Either.Left.create(new ServerError(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "status";
                        }
                    })())(Data_Symbol.SProxy.value)(v.value0)));
                };
            };
            throw new Error("Failed pattern match at Utils.DataLoading (line 65, column 5 - line 65, column 48): " + [ v.constructor.name ]);
        };
        return Data_Functor.map(Effect_Aff.functorAff)(handleResponse)(Affjax.request({
            method: request.method,
            url: request.url,
            headers: request.headers,
            content: request.content,
            username: request.username,
            password: request.password,
            withCredentials: request.withCredentials,
            responseFormat: Affjax_ResponseFormat.string,
            timeout: request.timeout
        }));
    };
};
var genericRemoteError = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new ServerError(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return NetworkError.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new DecodingError(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new ApplicationError(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Utils.DataLoading (line 43, column 1 - line 43, column 64): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ServerError) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof NetworkError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof DecodingError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof ApplicationError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at Utils.DataLoading (line 43, column 1 - line 43, column 64): " + [ x.constructor.name ]);
    }
};
var showRemoteError = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericRemoteError)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Affjax_StatusCode.showStatusCode))({
            reflectSymbol: function () {
                return "ServerError";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "NetworkError";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
            reflectSymbol: function () {
                return "DecodingError";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))({
            reflectSymbol: function () {
                return "ApplicationError";
            }
        })))))
    };
};
var fromApplicationError = function (v) {
    if (v instanceof ApplicationError) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var eqRemoteError = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericRemoteError)(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Affjax_StatusCode.eqStatusCode)))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(Data_Eq_Generic.genericEqSum(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqString)))(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(dictEq))))))
    };
};
export {
    ServerError,
    NetworkError,
    DecodingError,
    ApplicationError,
    fromApplicationError,
    simpleRequest,
    genericRemoteError,
    showRemoteError,
    eqRemoteError
};
//# sourceMappingURL=index.js.map
